import { useCallback } from "react";

import useTranslations from "@/shared/lang/useTranslations";
import { formatTaxLabel, isTransactionFeeTax, type PaymentTaxLine } from "@/shared/utils/paymentTaxes";

export type TaxLabelResolver = (tax: Pick<PaymentTaxLine, "code" | "name" | "rate">) => string;

/**
 * How an operation names one of its tax lines: "IVA 19 %" for most, and a plain "Costo de transacción" — no
 * name, no rate — for the 4x1000 (`isTransactionFeeTax`). Every screen that shows an operation's money goes
 * through this. Only the price-book configuration, where staff define the tax, still reads the real name with
 * `formatTaxLabel`.
 */
export function useTaxLabel(): TaxLabelResolver {
  const { t, activeLanguage } = useTranslations("global");

  return useCallback(
    (tax) => (isTransactionFeeTax(tax) ? t("tax_transaction_cost") : formatTaxLabel(tax, activeLanguage)),
    [t, activeLanguage],
  );
}
